import { expenses } from './role'

export const queries = {
  expenses,
}
export default queries
